@if (!categoryStore.asArray().length) {
  <app-alert header="Keine Indikatoren-Bereiche vorhanden" [canToggle]="false">
    Legen Sie zuerst Indikatoren-Bereiche über das
    <a
      [routerLink]="[
        '/data-backend',
        {
          outlets: {
            overlay: [
              'neu',
              { outlets: { panel: ['indikatoren-bereich', 'neu'] } },
            ],
          },
        },
      ]"
      >Formular</a
    >
    an.
  </app-alert>
  <p-divider />
}

<div *ngIf="!categoryStep">
  <app-pool-filter></app-pool-filter>
  <div class="grid">
    <div class="col-12" *ngIf="indicatorStore.poolFiltered() as poolIndicators">
      <p-pickList
        #listPickerCtrl
        [source]="poolIndicators"
        [target]="selected"
        sourceHeader="Indikatoren"
        targetHeader="Auswahl"
        [dragdrop]="true"
        [responsive]="true"
        [showSourceControls]="false"
        [showTargetControls]="true"
        [sourceStyle]="{ height: '30rem' }"
        [targetStyle]="{ height: '30rem' }"
        breakpoint="1400px">
        <ng-template pTemplate="targetHeader">
          Auswahl <br />
          <span class="font-light text-color-secondary text-xs"
            >Diese Indikatoren werden Ihrem Indikatorenverzeichnis
            hinzugefügt.</span
          >
        </ng-template>
        <ng-template let-indicator pTemplate="item">
          <p-contextMenu
            [target]="cm"
            [model]="contextMenu"
            appendTo="body"></p-contextMenu>
          <div
            pTooltip="Rechtsklich für weitere Informationen"
            [showDelay]="1000"
            (contextmenu)="onContextMenuOpen($event, indicator)"
            #cm
            class="flex-1 flex flex-column gap-2"
            [ngClass]="{ 'pl-3': indicator.parent }">
            <div class="flex align-items-center gap-2 text-lg">
              <i
                class="fas"
                [ngClass]="{
                  'fa-ruler-combined': indicator.isSet,
                  'fa-ruler-vertical': !indicator.isSet,
                }"></i>
              <span>
                {{ indicator.name }}
              </span>
              <p-badge
                class="ml-auto"
                *ngIf="units[indicator.unit]"
                [value]="
                  units[indicator.unit].symbol || units[indicator.unit].name
                "></p-badge>
            </div>

            <app-tag-list
              styleClass="text-xs"
              *ngIf="indicator.tags?.length"
              [tagIds]="indicator.tags"></app-tag-list>

            <app-tag-list
              severity="warning"
              styleClass="text-xs"
              *ngIf="indicator.products?.length"
              [tagIds]="indicator.products"></app-tag-list>
          </div>
        </ng-template>
      </p-pickList>
    </div>
  </div>

  <p-divider></p-divider>
  <footer class="flex align-items-center gap-3">
    <p-button
      [disabled]="selected.length === 0"
      class="ml-auto"
      label="hinzufügen"
      icon="fas fa-check-circle"
      [rounded]="true"
      (click)="selectForCopy()"></p-button>
  </footer>
</div>

<p-sidebar
  [(visible)]="displayIndicatorDetails"
  [styleClass]="'w-6'"
  position="right"
  [modal]="true"
  appendTo="body"
  (onHide)="closeOverlay()">
  <app-indicator-detail [indicator]="indicatorToShow" />
</p-sidebar>

@if (categoryStep) {
  <div class="grid">
    <div class="col-12">
      <app-header
        icon="fas fa-folder-open"
        sub="In welchen Ordner sollen die Indikatoren kopiert werden?"
        text="Ordner auswählen"></app-header>
      <app-category-tree
        (categorySelection)="
          copyIndicatorConfirmation($event)
        "></app-category-tree>
    </div>
  </div>
  <p-divider />
  <footer class="flex align-items-center gap-3">
    <p-button
      severity="secondary"
      [rounded]="true"
      [outlined]="true"
      icon="fas fa-xmark"
      (click)="cancel()"
      label="abbrechen"></p-button>
    <p-button
      severity="secondary"
      [rounded]="true"
      [outlined]="true"
      icon="fas fa-arrow-left"
      (click)="back()"
      label="zurück"></p-button>
  </footer>
}

<p-confirmDialog
  key="copyFromPool"
  #cd
  styleClass="w-6"
  appendTo="body"
  [blockScroll]="false">
  <ng-template pTemplate="headless" let-message>
    <div class="p-card border-round pt-1 p-4">
      <app-header icon="fas fa-copy" [text]="message.header"></app-header>

      <div class="flex">
        Die Indikatoren werden mit den Metainformationen in Ihr
        Indikatorenverzeichnis kopiert. Überprüfen Sie die Metainformationen auf
        die Gültigkeit in Ihrer Kommune.
      </div>

      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="abbrechen"
          (click)="cd.reject()"></button>
        <button
          [rounded]="true"
          pButton
          severity="success"
          icon="fas fa-check"
          label="Indikatoren übertragen"
          (click)="cd.accept()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
